module.exports = __webpack_public_path__ + "img/ng.70bd8b2f.svg";